import { type ChipProps } from "ui/chip";

import type { TouchpointDTOClassesItem } from "generated/schemas";

/**
 * The four classes are a categorical scale, not a severity one — the names of the slots carry no
 * meaning here beyond keeping the four pills distinguishable at a glance. `FRESHMAN` was Figma's
 * `lime`, which the design system dropped; `success` keeps it green and keeps the four distinct.
 */
export const TOUCHPOINT_CLASS_CHIP_COLORS: Record<
  TouchpointDTOClassesItem,
  NonNullable<ChipProps["color"]>
> = {
  SENIOR: "warning",
  JUNIOR: "secondary",
  SOPHOMORE: "info",
  FRESHMAN: "success",
};

export const getTouchpointClassChipColor = (
  classType: string,
): NonNullable<ChipProps["color"]> =>
  TOUCHPOINT_CLASS_CHIP_COLORS[classType as TouchpointDTOClassesItem] ?? "default";
